import { Grid } from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import { useEffect } from "react";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  setFieldsSettings,
}) {
  const fields = [
    {
      type: "text",
      name: "title",
      label: "Title",
      localized: true,
    },
    {
      type: "datetime",
      name: "date",
      label: "Event Date",
      localized: true,
      md: 6,
    },
    {
      type: "text",
      name: "video_url",
      label: "Video URL",
      localized: true,
      md: 6,
    },
    {
      label: "Image",
      name: "image",
      required: true,
      type: "image",
      width: "100%",
      height: 350,
      elevation: 0,
      md: 4,
    },
    {
      type: "space",
      height: "3em",
    },
    {
      label: "Content",
      name: "content",
      required: true,
      type: "editor",
      localized: true,
    },
  ];

  useEffect(() => {
    setFieldsSettings(fields);
  }, []);

  return (
    <Grid container spacing={2} justifyContent="center">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
